import React from "react";
import PropTypes from "prop-types";
import "./EVs.scss";
import { Link } from "react-router-dom";

import EVCatalog from "./../../components/EVCatalog/EVCatalog";
import MatchScoreOptions from "./../../components/MatchScoreOptions/MatchScoreOptions";
import EvSortControls from "./../../components/EvSortControls/EvSortControls";

import EVFilterControls from "./../../components/EVFilterControls/EVFilterControls";
import ModalComponent from "../../components/ModalUIComponent/ModalUIComponent";
import WhiteTiles from "../../client_customizations/assets/images/white_tiles.svg"
import GraphIcon from "../../client_customizations/assets/images/Graph_Icon.svg"
import ActiveGraphIcon from "../../client_customizations/assets/images/Active_Graph_Icon.svg"

import {FormattedMessage, useIntl} from 'react-intl';

const EVs = ({ electricVehicles, ip, uuid }) => {
  const intl = useIntl() 
  
  const time = new Date().toLocaleString();

  const renderOptions = (
    <>
      {<MatchScoreOptions /> }
      <br />
      <EVFilterControls vehicles={electricVehicles}/>
    </>
  );


  return (
    <section className="container" id="EVs">
      <div className="row mb-3">
        <div className="col-sm-12">
          <h1>
            <FormattedMessage 
              id="electricVehicles"
              defaultMessage="Electric Vehicles"
              description="Electric Vehicles"
            />
          </h1>
          <p className="lead">
            <FormattedMessage 
              id="evs.welcomeSub"
              defaultMessage="Compare electric cars by EV range, price, or your personalized Match Score. {lineBreak} Click on the EV for more details, including total cost compared to a similar gas vehicle."
              description="Description of Colton Recharged"
              values= {{
                lineBreak: <br />
              }}
            />
            </p>
        </div>
      </div>
      <div className="row justify-content-center evsToggle d-none d-lg-block">
        <Link
          to={`/vehicles`}
        >
          <button
            type="button"
            className="toggle-btn-active"
          >
            <img 
              className="evs-toggle-image" 
              alt="White Tile Icon"
              src={WhiteTiles}>
            </img>
              Vehicle Tiles
          </button>
        </Link>

        <Link
          to={`/comparison-graph`}
        >
          <button
            type="button"
            className="toggle-btn"
          >
            <img 
              className="evs-toggle-image evs-toggle-image-passive" 
              alt="Graph Icon"
              src={GraphIcon}>
            </img>
            <img 
              className="evs-toggle-image evs-toggle-image-hover" 
              alt="Active White Graph Icon"
              src={ActiveGraphIcon}>
            </img>
              Range vs. Cost
          </button>
        </Link>
      </div>
      <div className="row">
        <div className="col-sm-12 d-block d-lg-none text-center">
          <ModalComponent
            buttonText={intl.formatMessage ? intl.formatMessage({ id: "evs.buttonMatchScoreAndFilters", defaultMessage: "Match Score and Filters"}) : "Match Score and Filters"}
            titleText={intl.formatMessage ? intl.formatMessage({ id: "evs.matchScoreAndFilters", defaultMessage: "Refine Match Score and Filters"}) : "Refine Match Score and Filters"}
          >
            {renderOptions}
          </ModalComponent>
          <br />
        </div>
        <div className="col-xl-3 col-lg-4 d-none d-lg-block">
          {renderOptions}
        </div>
        <div
          id="electric-vehicles-catalog"
          aria-live="polite"
          aria-atomic="true"
          role="region"
          style={{ position: "absolute", top: "-9999px" }}
        >
          <span>Results have been updated as of {time}.</span>
        </div>
        <div
          className="col-xl-9 col-lg-8 col-sm-12"
          style={{ paddingLeft: 10 }}
        >
          <div className="row">
            <div className="col">
              <div className="pull-right">
                {<EvSortControls />}
              </div>
            </div>
          </div>
          {
            <EVCatalog
              vehicles={electricVehicles}
              hasEvDetails
              hasIncentivesAndMatchScore
            />
          }
        </div>
      </div>
    </section>
  );
};

export default EVs;

EVs.propTypes = {
  electricVehicles: PropTypes.array,
  ip: PropTypes.string,
  uuid: PropTypes.string
};
